import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { CustomerPaymentEmailReceiptComponent } from './customer-payment.email-receipt.component';
import { CustomerPaymentMethodPipe }            from './customer-payment.method.pipe';
import { CustomerPaymentsMethodsComponent }     from './customer-payments.methods.component';
import { CustomerPaymentsService }              from './customer-payments.service';
import { CustomerPaymentStatusPipe }            from './customer-payment.status.pipe';
import { SharedModule }                         from '../shared/shared.module';
import { TableModule }                          from '../table/table.module';

@NgModule({
  declarations: [
    CustomerPaymentEmailReceiptComponent,
    CustomerPaymentMethodPipe,
    CustomerPaymentsMethodsComponent,
    CustomerPaymentStatusPipe,
  ],
  entryComponents: [
    CustomerPaymentEmailReceiptComponent,
    CustomerPaymentsMethodsComponent
  ],
  exports: [
    CustomerPaymentMethodPipe,
    CustomerPaymentStatusPipe,
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CustomerPaymentMethodPipe,
    CustomerPaymentsService,
    CustomerPaymentStatusPipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'customerPaymentMethod',
      useClass: CustomerPaymentMethodPipe
    },
    {
      provide : 'customerPaymentStatus',
      useClass: CustomerPaymentStatusPipe
    }
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class CustomerPaymentsModule {}